// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HowToCards_wrapper__WlAH1","intro":"HowToCards_intro__4kj3b"};